  export const themeConfig = {
    light: {
      backgroundColor: '#ffffff',
      textColor: '#131722',
      gridColor: '#e1e3e6',
      borderColor: '#e1e3e6',
      crosshairColor: '#9598a1',
      priceLineColor: '#4c525e',
      upColor: '#089981',
      downColor: '#f23645',
      borderUpColor: '#089981',
      borderDownColor: '#f23645',
      wickUpColor: '#089981',
      wickDownColor: '#f23645',
      volumeUpColor: 'rgba(8, 153, 129, 0.8)',
      volumeDownColor: 'rgba(242, 54, 69, 0.8)',
      headerBg: '#f8f9fa',
      headerText: '#131722',
      headerBorder: '#e1e3e6'
    },
    dark: {
      backgroundColor: '#030e26',
      textColor: '#d1d4dc',
      gridColor: '#363a45',
      borderColor: '#4c525e',
      crosshairColor: '#9598a1',
      priceLineColor: '#4c525e',
      upColor: '#089981',
      downColor: '#f23645',
      borderUpColor: '#089981',
      borderDownColor: '#f23645',
      wickUpColor: '#089981',
      wickDownColor: '#f23645',
      volumeUpColor: 'rgba(8, 153, 129, 0.8)',
      volumeDownColor: 'rgba(242, 54, 69, 0.8)',
      headerBg: '#02091c',
      headerText: '#d1d4dc',
      headerBorder: '#363a45'
    }
  };